module.exports = __webpack_public_path__ + "static/d18c3260-0c75-4ac2-9c0c-aa452042c5a4-065c9eb66e0874c86bdebdf51dcd168a.woff2";